import React from 'react';

import { Toolbar, Typography } from '@material-ui/core';

import { createColumn } from '../../../components/dynamic-table';
import { ExpandableTable } from '../../../components/expandable-table';
import { createCommonSubmissionsTableColumns } from '../commons/columns';
import { useStyles } from '../commons/styles';
import { getPendingSubmissions } from '../commons/utils';

import { SubmissionCardsTable } from './submission-cards-table';

const commonSubmissionsTableColumns = createCommonSubmissionsTableColumns();

export function PendingSubmissionsTable(props) {
  const { allSubmissions, allSubmissionsCards, renderActions } = props;

  const classes = useStyles();
  const pendingSubmissions = getPendingSubmissions(allSubmissions);

  // if (pendingSubmissions.length <= 0) {
  //   return null;
  // }

  const pendingSubmissionsTableColumns = [
    ...commonSubmissionsTableColumns,
  ];

  if (typeof renderActions === 'function') {
    const actionsColumn = createColumn('Actions', {
      align: 'right',
      colSpan: 1,
      size: 'small',
      sortable: false,
      render: renderActions,
    });

    pendingSubmissionsTableColumns.push(actionsColumn);
  }

  return (
    <>
      <Toolbar className={classes.toolbar}>
        <Typography variant="h6">Pending submissions</Typography>
        <Typography variant="subtitle1">The checkout of these submissions was never completed</Typography>
      </Toolbar>

      <ExpandableTable columns={pendingSubmissionsTableColumns} rows={pendingSubmissions}>
        {row => (
          <SubmissionCardsTable
            allSubmissionsCards={allSubmissionsCards}
            submission={row}
          />
        )}
      </ExpandableTable>
    </>
  );
}
